import React from 'react';
import CommonAttributeTable from './CommonAttributeTable';
import NoDataComponent from 'Components/Common/NoDataComponent';

type TCommonAttributesProps = {
  recategorizationResponse: RecategorizationResponse | undefined;
  payload: TRecategorizePayload;
  setPayload: React.Dispatch<React.SetStateAction<TRecategorizePayload>>;
}

const CommonAttributes = ({recategorizationResponse, payload, setPayload}: TCommonAttributesProps) => {

  if (recategorizationResponse?.common_attr_list.length === 0) {
    return <NoDataComponent />;
  }

  return (
    <div className='tw-mt-3'>
      <CommonAttributeTable recategorizationResponse={recategorizationResponse} payload={payload} setPayload={setPayload} />
    </div>
  );
}

export default CommonAttributes;